import CardGroup from "../components/dashboard/CardGroup";
import ChartGroup from "../components/dashboard/ChartGroup";
import { DateRangePickesrButton } from "../components/common";
import { useEffect, useState } from "react";
import moment from "moment";
import formatDateRangeLabel from "../components/common/utils";
import ItemKeyPoints from "../components/dashboard/itemKeyPoint";


function AnalyticsHome() {
  const [filterParams, setFilterParams] = useState<any>({
    start_date: '',
    end_date: '',
  });

  const defaultValue = {
    startDate: new Date(new Date().setDate(new Date().getDate() - new Date().getDay())),
    endDate: new Date(new Date().setDate(new Date().getDate() + (6 - new Date().getDay()))), 
    key: 'selection'
  };

  useEffect(() =>  {
    setFilterParams({
      start_date: moment(defaultValue.startDate).format('YYYY-MM-DD'),
      end_date: moment(defaultValue.endDate).format('YYYY-MM-DD'),
      range_name: formatDateRangeLabel(defaultValue.startDate, defaultValue.endDate)
    });
  }, []);


  const onDateRangeApply = (range: any) => {
    setFilterParams({
      start_date: moment(range.startDate).format('YYYY-MM-DD'),
      end_date: moment(range.endDate).format('YYYY-MM-DD'),
      range_name: formatDateRangeLabel(range.startDate, range.endDate)
    });
      
  };

  return (
    <main className="px-5 md:px-10 w-full">
      <div className="pt-2">
        <DateRangePickesrButton size="sm" onApply={onDateRangeApply} initialLabel="Today" defaultValue={defaultValue} />
      </div>
      <CardGroup filterParams={filterParams} />
      <ItemKeyPoints filterParams={filterParams} />
      <ChartGroup filterParams={filterParams} />
      {/* <MostSellingProducts />
      <MostSellingProducts />
      <MostSellingProducts /> */}
    </main>
  );
}

export default AnalyticsHome;
